import script from "./claimPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./claimPopup.vue?vue&type=script&setup=true&lang=ts"

import "./claimPopup.vue?vue&type=style&index=0&id=1938ccf6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1938ccf6"]])

export default __exports__